import { render, staticRenderFns } from "./WideFooter.vue?vue&type=template&id=0cc65daa&scoped=true&"
import script from "./WideFooter.vue?vue&type=script&lang=js&"
export * from "./WideFooter.vue?vue&type=script&lang=js&"
import style0 from "./WideFooter.vue?vue&type=style&index=0&id=0cc65daa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc65daa",
  null
  
)

export default component.exports